/*
Author: Vaishnavi
Date: 26/11/2019
Issue Description: Spacing fixes done as per design guidelines
*/

/*
Author: Vaishnavi
Date: 17/04/2020
Issue Description: When trying to edit/Add Subcategories getting issue.
Issue ID: PL-3068
serach_string: PL_3068
*/
<template>
  <div class="business">
    <div class="top-bar">
      <span @click="goBackToBandPage">
        <img src="@/assets/path-2-copy.png" />
      </span>
      <span class="heading_new">{{headerText}}</span>
    </div>
    <div class="main-container">
      <div class="addlocationClass" v-if="!editMode">
        <tl-radio
          name="uploadMethod"
          label="Bulk Upload"
          id="bulkUpload"
          value="bulkUpload"
          v-model="uploadMethod"
        />
        <tl-radio
          name="uploadMethod"
          label="Manual"
          id="manualUpload"
          value="manualUpload"
          v-model="uploadMethod"
        />
      </div>
      <toast-message
        :message="errmsg"
        type="error"
        :isToastEnable="toast"
        @close="(val) => toast = val"
      />
      <div class="margin-t-l" v-if="uploadMethod == 'bulkUpload'">
        <div>
          <div class="download-btn">
            <div class="download-btn-container">
            <img src="@/assets/download.svg"  class="img" />
            <span class="text" @click="downloadUrl">Download Template</span>
            <loading-animation v-show="showLoader"></loading-animation>
         </div>
          </div>
          <upload-file :apiUrl="bulkUploadUrl" class="margin-t-15px" @uploadTemplate="onUploadTemplate($event)"></upload-file>
        </div>
      </div>
      <div v-else class="margin-t-l">
        <div class="content-new">
          <section class>
            <txt
              label="Enter Category Name *"
              type="text"
              v-model="formData.name"
              placeholder="Enter Name"
              name="categoryName"
              data-vv-as="category name"
              v-validate="{required: true, max: nameMaxlength}"
              :classname="errors.has('categoryName')"
              :errormsg="errors.first('categoryName')"
            />
            <div class="margin-t-m" v-for="(item, i) in formData.subCategory" :key="i">
              <txt
                autofocus="autofocus"
                label="Enter Sub Category Name"
                type="text"
                v-model="formData.subCategory[i].name"
                placeholder="Enter Sub Category Name"
                name="empSubcategoryName"
                data-vv-as="sub category name"
                v-validate="{required: false, max: nameMaxlength}"
                :classname="errors.has('empSubcategoryName'+i)"
                :errormsg="errors.first('empSubcategoryName'+i)"
              />
              <div>
                <a
                  class="delete"
                  v-on:click="deleteSubCategory(i)"
                  v-if="formData.subCategory.length > 1"
                >Delete</a>
              </div>
            </div>
            <div class="row-container margin-t-m align-center">
              <img src="@/assets/group-5.svg" @click="addNewSubCategory()" />
              <button class="text-green" @click="addNewSubCategory()">Add New Sub Category</button>
            </div>
            <txt
              class="margin-t-m"
              autofocus="autofocus"
              label="Description"
              maxlength="250"
              type="textarea"
              placeholder="Description"
              v-model="formData.description"
              name="empCategoryDescription"
              rows="6"
              data-vv-as="description"
              v-validate="{required: false, max: descriptionMaxlength}"
              :classname="errors.has('empCategoryDescription')"
              :errormsg="errors.first('empCategoryDescription')"
            />
          </section>
        </div>
      </div>
      <pop-up-message
        v-if="showSuccessBulkUploadMsg"
        :message="responseMsg"
        btnText="Back To Employee Category"
        @back="backfrompopup()"
      ></pop-up-message>
      <footer>
        <toast-message :message="errmsg" v-show="toast" type="error" />
        <pop-up-message
          v-if="showSuccessMsg"
          :message="`${formData.name} has been successfully ${editMode ? 'updated' : 'created'}`"
          btnText="Back To Employee Category"
          @back="backfrompopup()"
        />
        <bottom-action-container class="position-fixed">
          <btn-grp slot="end">
            <btn text="Cancel" type="secondary" v-on:click="goBackToBandPage"></btn>
            <btn
              :text="btnText"
              type="primary"
              :disabled="uploadMethod=='bulkUpload' && file==''"
              v-on:click="save"
            ></btn>
          </btn-grp>
        </bottom-action-container>
      </footer>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters, mapState } from "vuex";
import { createDecipheriv } from 'crypto';
import * as config from "@/apis/config.js";
import { api_variables } from "@/apis/variables.js";
import axios from "axios";
import {S3} from "aws-sdk";
export default {
  name: "addbusinessunit",
  data() {
    return {
      showLoader: false,
      bulkUploadTemplateUrl:'https://paylief.s3.ap-south-1.amazonaws.com/paylief-bulk-upload-templates/employeeCategory.xlsx',
      bulkUploadUrl: api_variables.SERVICE_EMPLOYEE_CATEGORIES_UPLOAD_TEMPLATE,
      nameMaxlength: null,
      descriptionMaxlength: null,
      responseMsg: "",
      showSuccessBulkUploadMsg: false,
      formData: {
        name: "",
        subCategoryName: "",
        description: "",
        subCategory: [{ name: "" }]
      },
      errmsg: "",
      showSuccessMsg: false,
      uploadMethod: "manualUpload",
      toast: false,
      headerText: "",
      file: ""
    };
  },
  computed: {
    ...mapGetters({
      getleid: "onboard/legal_entities/legal_entity_ID",
      record: "onboard/empCategory/record",
      editMode: "onboard/empCategory/editMode"
    }),

    le_id() {
      if (this.$route.params.entity_index)
        return this.getleid(this.$route.params.entity_index);
      else return this.getleid(0);
    },

    btnText() {
      if (this.editMode) {
        return "Update";
      } else {
        return "Add New";
      }
    },
    isEditMode() {
      return this.mode == "edit";
    }
  },
  activated() {
    this.refresh();
    this.setGlobalValidations();
    if (this.editMode) {
      this.formData = this.record;
      this.formData.subCategory = this.record.subCategory && this.record.subCategory.length   // PL_3068
        ? this.record.subCategory
        : [];
      this.headerText = "Employee Category - " + this.formData.name;
      this.uploadMethod = "manualUpload";
    } else {
      this.headerText = "Employee Categories";
      this.uploadMethod = "manualUpload";
    }
  },
  methods: {
    ...mapActions("onboard/empCategory/", {
      act_create: "create",
      act_update: "update",
      act_upload_template: "uploadTemplate"
    }),
    ...mapActions("payroll/lopsandrlops/", {
    getPreSignedUrl: "createPreSigned"
  }),
  async preSignedUrlFunction() {
  try {
    let res = await this.getPreSignedUrl({
      url: this.bulkUploadTemplateUrl
    });
    if (res.data.payload && res.data.payload.iv && res.data.payload.encryptedPacket) {
      const decryptedLink = await this.decrypt(res.data.payload);
      return decryptedLink;
    } else {
      console.log('Invalid payload structure');
      return null;
    } 
  } catch (e) {
    console.log('Error in preSignedUrlFunction:', e);
    return null; 
  }
},

async downloadUrl() {
      try {
        const downloadLink = await this.preSignedUrlFunction();
        if (downloadLink) {
          let url = JSON.parse(downloadLink);
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "Employee_category.xls"); //or any other extension
          document.body.appendChild(link);
          link.click();
        } else {
          console.log('Failed to retrieve the download link.');
        }
      } catch (e) {
        console.error('Error during download:', e);
      }
    },
    async decrypt(payload){
    const key = process.env.VUE_APP_PAYSLIP_SECRET;
    const decipher = createDecipheriv('aes-256-cbc', key, Buffer.from(payload.iv, 'hex'));
    const decrypted = Buffer.concat([
        decipher.update(payload.encryptedPacket, 'base64'),
        decipher.final()
    ]);

    return decrypted.toString();
},
   
    /* function to set default configuration for validation */
    setGlobalValidations(){
      try {
        this.nameMaxlength = config.MaxLengthSettings.nameLength;
        this.descriptionMaxlength = config.MaxLengthSettings.descriptionLength;
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to get reaponse after uploading file for bulk upload */
    async onUploadTemplate(res) {
      try {
          if (res.data && res.data.status) {
            this.responseMsg = res.data.message ? res.data.message : "";
            this.showSuccessBulkUploadMsg = true;
          } else {
            this.toast = true;
            this.errmsg = res.message;
          }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },


    /* function to hide the success pop-up and go back to main employee category page */
    backfrompopup() {
      this.refresh();
      this.showSuccessMsg = false;
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/empCategories`
      });
    },

    /* server call to create or update employee categories */
    async performAction() {
      try {
        let obj = {
          data: {
            name: this.formData.name.trim(),
            description: this.formData.description,
            le_id: this.le_id,
            subCategory: this.formData.subCategory
              .map(item => {
                return { name: item.name.trim() };
              })
              .filter(item => item.name != "" && item.name != null)
          }
        };
        this.$root._data.isSaving = true;
        let res = null;
        if (this.editMode) {
          obj.data["id"] = this.record.id;
          res = await this.act_update(obj);
        } else {
          res = await this.act_create(obj);
        }
        if (res.data.status) {
          this.showSuccessMsg = true;
          this.$root._data.isSaving = false;
        }
      } catch (err) {
        this.$root._data.isSaving = false;
        this.toast = true;
        this.errmsg = err;
      }
    },

    /* function to go back to previous page */
    goBackToBandPage() {
      this.refresh();
      this.$router.push({
        path: `/onboarding/entity/${this.$route.params.entity_index}/empCategories`
      });
    },

    /* function to reset the form */
    refresh() {
      try {
        this.formData = {
          name: "",
          subCategoryName: "",
          description: "",
          subCategory: [{ name: "" }]
        };
        this.toast = false;
        this.showSuccessBulkUploadMsg = false;
        this.errmsg = "";
        this.$validator.reset();
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to validate the form */
    save() {
      this.$validator.validateAll().then(result => {
        if (result) {
          this.performAction();
        } else {
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .focus();
          this.$el
            .querySelector(
              '[data-vv-name="' + this.$validator.errors.items[0].field + '"]'
            )
            .scrollIntoView({
              behavior: "smooth",
              block: "center",
              inline: "center"
            });
        }
      });
    },

    /* function to add new sub categories */
    addNewSubCategory() {
      try {
        this.formData.subCategory.push({ name: "" });
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    },

    /* function to delete sub-categories */
    deleteSubCategory(i) {
      try {
        this.formData.subCategory.splice(i, 1);
      } catch (error) {
        this.toast = true;
        this.errmsg = error;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import "@/scss/components/margins.scss";
@import "../../../../../../scss/variables";
.download-btn-container {
  display: flex;
  align-items: normal;
  .img {
    height: 18px;
    width: 16px;
    object-fit: contain;
  }
  .text {
    font-size: 14px;
    font-weight: 600;
    color: $color-secondary;
    margin-left: 8px;
    cursor: pointer;
  }
}
bottom-action-container.position-fixed {
  position: fixed;
}
.content-new {
  .errorr {
    border: 1px solid #e01717;
  }
  .errorMessage {
    color: #e01717; // padding-top: 1px
  }
}

footer {
  height: 50px;
  flex-shrink: 0; //   position: fixed;
}

.business {
  width: 100%;
  height: 100%;
  .top-bar {
    height: 64px;
    box-shadow: 0 1px 18px 0 rgba(0, 0, 0, 0.12);
    background-color: #ffffff;
    padding: 24px 0 0 32px;
    img {
      cursor: pointer;
      margin-right: 24px;
    }
  }
}

.heading_new {
  height: 19px;
  font-size: 16px;
  font-weight: 600;
  color: #6e6e6e;
}

.addlocationClass {
  display: flex;
}

.delete {
  font-family: Montserrat;
  font-size: 12px;
  color: #5d409f;
  margin-left: 260px;
  text-decoration: underline;
  cursor: pointer;
}
</style>
